<template>
  <h2 class="heading">{{ heading }}</h2>

  <p class="text">
    {{ text }}
  </p>

  <BenefitIcons
    :items="{
      star: 'Exclusive rewards',
      'sell-tag': 'Priority sale access',
      'add-task': 'Vote on styles',
    }"
  />

  <SingleSignOn />

  <div class="divider">or</div>

  <RegisterForm @success="handleRegisterSuccess" />
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { signUpBonus } from "@/config";
import RegisterForm from "@/components/account/RegisterForm.vue";
import SingleSignOn from "@/components/SingleSignOn.vue";
import BenefitIcons from "@/components/BenefitIcons.vue";

export default {
  name: "RegisterPanel",
  components: {
    RegisterForm,
    SingleSignOn,
    BenefitIcons,
  },
  emits: ["success"],
  data() {
    return {
      showBenefitIcons: false,
      heading: null,
      text: null,
    };
  },
  computed: {
    ...mapGetters("app", ["currencyCode"]),
    ...mapState("auth", ["multipassAccount"]),
    bonus() {
      if (!this.currencyCode) {
        return null;
      }
      const amount = signUpBonus[this.currencyCode];
      return this.$filters.toCurrency(amount, this.currencyCode, 0);
    },
  },
  watch: {
    bonus(newBonus) {
      if (!newBonus) {
        return;
      }
      this.setHeadingAndText(newBonus);
    },
  },
  mounted() {
    this.setHeadingAndText();
  },
  methods: {
    setHeadingAndText() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const refParam = urlParams.get("ref");

      if (refParam === "sale") {
        this.heading = "Your Early Access Starts Here";
        this.text =
          "It's not too late to join and get ahead of the crowd, create an account to access the sale one hour early";
        this.showBenefitIcons = false; // Hide BenefitIcons when refParam is "sale"
      } else {
        this.heading = `${this.bonus} Credit Towards Order`;
        this.text = `Sign up and create a Members Only account to receive ${this.bonus} credit* towards your first order, enjoy rewards and benefits, and be the first to know about all things Rat & Boa. Credit cannot be used on sale items.`;
        this.showBenefitIcons = true; // Show BenefitIcons for other cases
      }
    },
    handleRegisterSuccess() {
      this.$emit("success");

      const VWO = window.VWO || [];
      VWO.event =
        VWO.event ||
        function () {
          VWO.push(["event"].concat([].slice.call(arguments)));
        };

      VWO.event("accountSignup", {
        signup: "success",
      });

      window.location.href = this.multipassAccount.url;
    },
  },
};
</script>

<style lang="scss" scoped>
.divider {
  position: relative;
  text-align: center;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 600;
  margin-bottom: 20px;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border-bottom: solid 1px #d4d4d4;
    width: 40%;
    left: 0;
  }

  &::after {
    left: auto;
    right: 0;
  }
}

.sso-buttons {
  border-bottom: none;
  margin: 0 -20px 40px;
  padding: 0 20px;

  ::v-deep(.button) {
    &:first-child {
      margin: 0 0 10px 0;
    }
  }
}

.heading {
  margin-top: 20px;
  text-align: center;
  font-size: 28px;
  font-weight: 400;
  text-transform: uppercase;
}

.text {
  font-size: 13px;
  margin: 10px 0 50px 0;
  text-align: center;
  font-weight: 400;
  font-family: $body-font-family;
}

::v-deep(.loyalty-benefits-icons) {
  margin: 30px auto;

  @include respond-above(md) {
    margin: 30px auto;
  }

  p {
    font-size: 13px;
  }
}
</style>
